import Hintbox from '../../HintBox/HintBox';
import { compose, mdsWidget } from 'dojo/_base/declare';




class HintBoxLegacy extends compose(Hintbox) {
    
}

export default mdsWidget(HintBoxLegacy);